import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.min.css'
import { spliceText } from '@/assets/js/util'
import head from '@/components/head';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import countTo from 'vue-count-to'
if (/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) { //移动端
  //TODO
  location.replace('http://www.cdjc.com.cn/m')
}
Vue.config.productionTip = false
Vue.prototype.spliceText = spliceText
Vue.use(VueAwesomeSwiper).use(ElementUI);
Vue.component('public-head',head)
Vue.component('countTo',countTo)
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
